import React, { useEffect, useState } from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CAROUSEL_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/oGCnypQkmNaCZGW5m1F2U4/torta-choco.jpg',
  alt: 'Torta de chocolate'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nhMQb5J9FUy98MrpCgpnCi/torta-helada.jpg',
  alt: 'Torta helada'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mScitXLFJBwBu3BdadS3oq/flan.jpg',
  alt: 'Flan casero'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xdfHUPp25begmweLu4qAi6/brownie.jpg',
  alt: 'Brownie recién horneado'
}];
export function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent(prev => (prev + 1) % CAROUSEL_IMAGES.length);
        setFading(false);
      }, 400);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative w-full min-h-screen flex items-center overflow-hidden" style={{
    background: 'linear-gradient(160deg, #FDF8F3 0%, #F5EDE0 50%, #EDE0D0 100%)'
  }} aria-label="Sección principal" data-id="element-168">
      {/* Decorative background blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'var(--blush)'
    }} data-id="element-169" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-15 blur-3xl pointer-events-none" style={{
      background: 'var(--sage)'
    }} data-id="element-170" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 py-10 lg:py-14 w-full" data-id="element-171">
        <div className="grid grid-cols-1 gap-16 items-center" data-id="element-172">
          {/* Left: Copy */}
          <div className="flex flex-col gap-6" data-id="element-173">
            {/* Badge */}
            <div className="flex items-center gap-1" data-id="element-174">
              <div className="flex" data-id="element-175">
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-176" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-177" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-178" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-179" />
                <StarIcon className="w-4 h-4 fill-current" style={{
                color: 'var(--gold)'
              }} aria-hidden="true" data-id="element-180" />
              </div>
              <span className="text-sm font-bold tracking-widest uppercase" style={{
              color: 'var(--gold-dark)'
            }} data-id="element-181">
                Método Dulce Libertad
              </span>
            </div>

            {/* Main headline */}
            <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold leading-tight text-center" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-182">
              Disfruta postres irresistibles sin inflamarte, sin azúcar{' '}
              <em className="italic" style={{
              color: 'var(--gold-dark)'
            }} data-id="element-183">
                y sin culpa
              </em>
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl leading-relaxed text-center" style={{
            color: '#1a0f0a',
            fontFamily: 'Cormorant Garamond, serif',
            fontStyle: 'italic',
            fontSize: '1.25rem',
            fontWeight: 600
          }} data-id="element-184">
              52 recetas de alta pastelería sin gluten, sin lácteos y sin
              azúcar, explicadas paso a paso con ingredientes que consigues en
              tu supermercado.
            </p>

            {/* Trust bullets */}

            {/* Price + CTA */}
            <div className="flex flex-col gap-4 md:gap-8 items-center" data-id="element-185">
              {/* Carousel */}
              <div className="w-full max-w-xl rounded-2xl overflow-hidden" style={{
              aspectRatio: '16/9',
              position: 'relative'
            }} data-id="element-186">
                <img src={CAROUSEL_IMAGES[current].src} alt={CAROUSEL_IMAGES[current].alt} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'opacity 0.4s ease',
                opacity: fading ? 0 : 1,
                display: 'block'
              }} data-id="element-187" />
                <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2" aria-hidden="true" data-id="element-188">
                  {CAROUSEL_IMAGES.map((_, i) => <span key={i} style={{
                  width: i === current ? 20 : 8,
                  height: 8,
                  borderRadius: 4,
                  background: i === current ? 'var(--gold)' : 'rgba(255,255,255,0.5)',
                  transition: 'all 0.3s ease',
                  display: 'inline-block'
                }} data-id="element-189" />)}
                </div>
              </div>

              <button onClick={() => {
              const target = document.getElementById('precio');
              if (target) {
                target.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }} className="btn-gold rounded-full flex items-center justify-center gap-3 px-10 py-5 text-lg font-bold uppercase tracking-wider w-full max-w-xl" aria-label="DESCARGAR AHORA" data-id="element-190">
                <span data-id="element-191">DESCARGAR AHORA</span>
              </button>
              <p className="text-sm text-center" style={{
              color: 'var(--text-muted)'
            }} data-id="element-192">
                Acceso inmediato • PDF en cualquier dispositivo • Garantía 30
                días
              </p>
            </div>
          </div>

          {/* Right: Product image */}
          <div className="flex flex-col items-center gap-2" data-id="element-193">
            <div className="relative" data-id="element-194">
              <div className="absolute inset-0 rounded-3xl blur-2xl opacity-30 scale-95" style={{
              background: 'var(--gold-light)'
            }} data-id="element-195" />
              <img src="https://cdn.magicpatterns.com/uploads/1xeyM8XY99HJAJT6xgmREj/heroprod.jpg" alt="Dulce Libertad — Ebook con 52 recetas de repostería sin gluten, sin lácteos y sin azúcar" className="relative z-10 w-full max-w-lg rounded-2xl shadow-2xl mb-[15px] -mt-8" style={{
              objectFit: 'cover'
            }} data-id="element-196" />
            </div>

            {/* Trust bullets — below product image */}
            <ul className="flex flex-col gap-3 w-full max-w-lg" role="list" data-id="element-197">
              <li className="flex items-center gap-3" data-id="element-198">
                <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'var(--sage)'
              }} data-id="element-199">
                  <CheckIcon className="w-3.5 h-3.5 text-white" aria-hidden="true" data-id="element-200" />
                </span>
                <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-201">
                  52 recetas probadas con familias reales
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-202">
                <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'var(--sage)'
              }} data-id="element-203">
                  <CheckIcon className="w-3.5 h-3.5 text-white" aria-hidden="true" data-id="element-204" />
                </span>
                <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-205">
                  Ingredientes fáciles de conseguir en el de supermercado
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-206">
                <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'var(--sage)'
              }} data-id="element-207">
                  <CheckIcon className="w-3.5 h-3.5 text-white" aria-hidden="true" data-id="element-208" />
                </span>
                <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-209">
                  Garantía de 30 días sin preguntas
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}